import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithEmergentSession } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        toast.error("No session detected");
        navigate("/login", { replace: true });
        return;
      }
      try {
        await loginWithEmergentSession(match[1]);
        window.history.replaceState({}, "", "/app");
        toast.success("Signed in with Google");
        navigate("/app", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    };
    run();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-slate-500">Signing you in…</div>
    </div>
  );
}
